module.exports = __webpack_public_path__ + "img/list.70465d36.svg";